export const YALLO_TV_URL =
  "https://yallo.tv/?utm_source=embeddedplayer&utm_medium=referral";
